import styled from 'styled-components';
import Button from '../Button/Button.es.js';

const SubAction = styled(Button).attrs(() => ({ variant: "subtle", kind: "link", size: "sm" }))``;
SubAction.displayName = "FeatureCard.SubAction";

export { SubAction };
//# sourceMappingURL=FeatureCardSubAction.es.js.map
